<script>
    import {_, locale} from 'svelte-i18n';
    import Item from './Item.svelte';
    import {gameConfig} from "../../stores.js";

    let { item, gameItem } = $props();
    let itemDetails = $state({});

    // cardCollection uses a 5-tier rarity scale (Unity parity).
    // Kept local — do not change the global itemRarity in constants.js.
    const cardCollectionRarity = {
        1: 'Common',
        2: 'Uncommon',
        3: 'Rare',
        4: 'Epic',
        5: 'Legendary',
    };

    // Plate mapping: shift one step down so each 5-tier rarity gets a distinct plate.
    // Common uses the neutral 'default' plate (added in Item.svelte for this case).
    const cardCollectionRarityPlate = {
        1: 'default',
        2: 'common',
        3: 'rare',
        4: 'epic',
        5: 'legendary',
    };

    const baseName = 'GenericCardCollectionPack';
    let rarity = $derived(cardCollectionRarity[gameItem.rarity] ?? 'Common');

    function setItemDetails() {
        itemDetails.title = $_(baseName + rarity + 'Title');
        itemDetails.description = $_(baseName + rarity + 'Description');
        itemDetails.amount = item.amount;
        itemDetails.icon = baseName + rarity + 'Item';
        itemDetails.rarity = gameItem.rarity;
        itemDetails.rarityClass = cardCollectionRarityPlate[gameItem.rarity] ?? 'default';
        itemDetails.expireAt = $gameConfig?.temporaryItems?.[item.id];
        itemDetails.claimed = item.claimed;
    }

    $effect(() => {
        $locale;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
